import { render, staticRenderFns } from "./gtr-module-widget.vue?vue&type=template&id=88cc49fa&scoped=true"
import script from "./gtr-module-widget.ts?vue&type=script&lang=ts&external"
export * from "./gtr-module-widget.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-module-widget.vue?vue&type=style&index=0&id=88cc49fa&prod&scoped=true&lang=css"
import style1 from "./gtr-module-widget.vue?vue&type=style&index=1&id=88cc49fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc49fa",
  null
  
)

export default component.exports